'use strict'

import HttpClient from './HttpClient'
// import store from '../../store'

class Email extends HttpClient {
  sendEmail (data = {}) {
    var url = '/api/admin/email/send'

    return this.sendPost(url, this.headers, data)
  }
}

export default Email
